<template>
  <div>
    <h1 class="mt-5">Biztosítás adatai</h1>
    <div class="form-group row">
      <div class="form-group row mb-2">
        <label class="col-sm-4">Kalkuláció azonosítója:</label>
        <div class="col-sm-8">
          {{ product_code }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Választott kártérítési limit:</label>
        <div class="col-sm-8">
          {{ limittomb[chosenLimit].nev.replaceAll(".", " ") }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Választott önrész:</label>
        <div class="col-sm-8">
          {{ onresz[chosenOnresz].replaceAll(".", " ") }}
        </div>
      </div>
      <div v-if="period_discount == 1" class="form-group row mb-2">
        <label class="col-sm-4">Tartamkedvezmény:</label>
        <div class="col-sm-8">
          {{ period_discount_text }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Díj:</label>
        <div class="col-sm-8">{{ premium | currency }}</div>
      </div>
      <div v-show="false" class="form-group row mb-2">
        <label class="col-sm-4">Limit opció:</label>
        <div class="col-sm-8">{{ limitName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Díjfizetés módja:</label>
        <div class="col-sm-8">{{ stringPaymentType }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Díjfizetés gyakorisága:</label>
        <div class="col-sm-8">{{ stringPaymentFrequency }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Kockázatviselés kezdete:</label>
        <div class="col-sm-8">
          {{ new Date(startDate).toLocaleDateString("hu-HU") }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Biztosított:</label>
        <div class="col-sm-8">
          Szerződő és a Szerződővel munkaviszonyban, munkavégzésre irányuló
          egyéb jogviszonyban álló személyek, valamint a Szerződő szolgáltatás
          teljesítése érdekében jogosan igénybevett közreműködő személyek – így
          különösen a Szerződő által bevont alvállalkozó – tevékenységéből eredő
          olyan károkra, amelyekért a Szerződőt kártérítési felelősség terheli.
          A közreműködő személyekre alvállalkozókra kizárólag a jelen
          szerződésben / kötvényen feltüntetett tevékenységek végzésével
          kapcsolatban vonatkozik a fedezet.
        </div>
      </div>
      <h2 class="mt-5">Cégadatok</h2>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Cég neve:</label>
        <div class="col-sm-8">{{ companyname }}</div>
      </div>
      <div v-show="false" class="form-group row mb-2">
        <label class="col-sm-4">Bejegyzés dátuma:</label>
        <div class="col-sm-8">
          {{ new Date(registrationdate).toLocaleDateString("hu-HU") }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Cég székhelye:</label>
        <div class="col-sm-8">
          {{ `${zip} ${city} ${streetname}  ${streettype} ${streetno}` }}
        </div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Cég adószáma:</label>
        <div class="col-sm-8">{{ displayedTaxNumber }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Cég nettó árbevétele:</label>
        <div class="col-sm-8">
          {{ net_income.toLocaleString("hu-HU") | currency }}
        </div>
      </div>

      <!-- <h2 class="mt-4">Cég székhelye</h2>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Irányítószám:</label>
        <div class="col-sm-8">{{ zip }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Település neve:</label>
        <div class="col-sm-8">{{ city }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület neve:</label>
        <div class="col-sm-8">{{ streetname }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület jellege:</label>
        <div class="col-sm-8">{{ streettype }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Házszám:</label>
        <div class="col-sm-8">{{ streetno }}</div>
      </div> -->
    </div>
    <h1 class="h2 mt-4" v-if="!$store.state.validateEmail">
      E-mail megerősítés
    </h1>
    <div class="form-group row mb-2" v-if="!$store.state.dm">
      <label class="col-sm-4" for="email_validation_code"
        >E-mailben kapott kód: <span class="text-danger">*</span></label
      >
      <ValidationProvider
        rules="required|email_verify_code"
        v-slot="{ errors, classes }"
        class="col-sm-4"
      >
        <input
          type="number"
          class="form-control"
          id="email_validation_code"
          name="email_validation_code"
          v-model="emailVerifyToken"
          :disabled="emailVerified"
          :class="{ 'is-valid': emailVerified, classes, 'dark-border': true }"
        />
        <small
          id="email_validation_code-error"
          class="text-danger input-alert"
          >{{ errors[0] }}</small
        >
      </ValidationProvider>
    </div>
    <div class="text-danger" v-if="!$store.state.validateEmail">
      Az e-mail cím megerősítése után az e-mail cím módosítása a későbbiekben
      már nem lehetséges.
    </div>
    <div v-if="merchant_id === 'colo213'">
      <h2 class="mt-4">Szerződő/kapcsolattartó adatai</h2>
      <div v-if="insuredLastName" class="form-group row mb-2">
        <label class="col-sm-4">Szerződő kapcsolattartó vezetékneve:</label>
        <div class="col-sm-8">{{ insuredLastName }}</div>
      </div>
      <div v-if="insuredFirstName" class="form-group row mb-2">
        <label class="col-sm-4">Szerződő kapcsolattartó keresztneve:</label>
        <div class="col-sm-8">{{ insuredFirstName }}</div>
      </div>
      <div v-if="insuredEmail" class="form-group row mb-2">
        <label class="col-sm-4">Szerződő kapcsolattartó email címe:</label>
        <div class="col-sm-8">{{ insuredEmail }}</div>
      </div>
      <div v-if="insuredPhoneNumber" class="form-group row mb-3">
        <label class="col-sm-4">Szerződő kapcsolattartó telefonszáma:</label>
        <div class="col-sm-8">
          +36 {{ insuredPhoneNumberArea }}
          {{ insuredPhoneNumber }}
        </div>
      </div>
      <br />
      <br />
    </div>
    <div v-if="merchant_id !== 'colo213'">
      <h2 class="mt-4">Biztostásközvetítő adatai</h2>
      <div v-if="brokernev" class="form-group row mb-2">
        <label class="col-sm-4">Biztostásközvetítő neve:</label>
        <div class="col-sm-8">{{ brokernev }}</div>
      </div>
      <div v-if="brokeremail" class="form-group row mb-2">
        <label class="col-sm-4">Biztostásközvetítő email címe:</label>
        <div class="col-sm-8">{{ brokeremail }}</div>
      </div>
      <div v-if="brokertel" class="form-group row mb-3">
        <label class="col-sm-4">Biztostásközvetítő telefonszáma:</label>
        <div class="col-sm-8">
          <!-- +36 {{ insuredPhoneNumberArea }} -->
          {{ brokertel }}
        </div>
      </div>
      <br />
      <br />
    </div>
    <h1>BIZTOSÍTÁSI FEDEZET</h1>
    <div class="form-group row mb-3">
      <label class="col-sm-4">Fedezet típusa:</label>
      <div class="col-sm-8">
        <b>Kivitelezői felelősségbiztosítási fedezet</b>, mely az alábbi
        fedezeti elemeket tartalmazza:
        <ul>
          <li>Általános felelősség</li>
          <li>
            Szolgáltatás felelősség (kiegészítve a szolgáltatás tárgyában
            okozott károkkal)
          </li>
          <li>Tűzveszélyes tevékenységek</li>
        </ul>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4">Biztosítási feltételek:</label>
      <div class="col-sm-8">
        A Colonnade Insurance S.A. Magyarországi Fióktelepe Kivitelezői
        Felelősségbiztosítása Biztosítási Feltételei ({{ tc_id }})
      </div>
    </div>
    <!-- <policy-coverage-vue></policy-coverage-vue> -->
    <h1 class="h2 mt-4">Nyilatkozatok</h1>
    <div class="form-group">
      <div class="form-check mb-4">
        <ValidationProvider
          name="biztositasi_feltetelek"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositasi_feltetelek"
            name="consents[]"
            value="biztositasi_feltetelek"
            v-model="insuranceTerms"
          />
        </ValidationProvider>
        <label for="biztositasi_feltetelek" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Biztosítási Feltételek és Ügyféltájékoztató elfogadása
            <div
              :class="insuranceTermsOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceTermsClick"
            ></div></b
          ><br />
          <div v-show="insuranceTermsOpened">
            Kijelentem, hogy megismertem és elfogadom a Colonnade Kivitelezői
            felelősségbiztosítása Biztosítási Feltételek és
            Ügyféltájékoztatóját.
            <iframe
              class="w-100 mt-2"
              style="height: 500px;"
              src="https://www.colonnade.hu/media/kivitelezoi-felelossegbiztositas-szerzodesi-feltetelek-es-ugyfeltajekoztato"
              frameborder="0"
            ></iframe>
          </div>
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="adatvedelmi_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="adatvedelmi_nyilatkozat"
            name="consents[]"
            value="adatvedelmi_nyilatkozat"
            v-model="privacyProtection"
          />
        </ValidationProvider>
        <label for="adatvedelmi_nyilatkozat" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; <b>Adatvédelmi nyilatkozat</b
          ><br />
          Kijelentem, hogy megismertem és elfogadom a biztosítási feltételek
          részét képező Adatvédelmi Szabályzatban leírtakat, amely alapján a
          Biztosító személyes adataimat gyűjti és kezeli. Amennyiben más
          személyek személyes adatait adtam meg/fogom megadni a Biztosítónak, az
          érintetteket tájékoztattam/tájékoztatni fogom az adatvédelmi
          szabályzat tartalmáról, illetve fel vagyok hatalmazva az érintett
          személyek személyes adatainak továbbítására. A Biztosító adatvédelmi
          szabályzata
          <a
            href="https://www.colonnade.hu/media/qb-colonnade-adatkezelesi-tajekoztato.pdf"
            target="_blank"
            >itt</a
          >
          elérhető.
        </label>
      </div>
      <div class="form-check mb-4">
        <input
          type="checkbox"
          class="form-check-input"
          id="hirlevel"
          name="consents[]"
          value="hirlevel"
          v-model="marketingMails"
        />
        <label for="hirlevel" class="form-check-label">
          <b>Szeretnék értesülni az aktuális ajánlatokról, akciókról</b><br />
          Kijelentem, hogy önkéntesen hozzájárulok ahhoz, hogy a Colonnade
          Insurance S.A. Magyarországi Fióktelepe a megadott személyes adataimat
          (név, telefonszám, e-mail cím) közvetlen üzletszerzés céljából kezelje
          és azokon megkeressen. Hozzájárulásomat bármikor, korlátozás és
          indoklás nélkül, ingyenesen visszavonhatom az info@colonnade.hu címre
          küldött emailben.
        </label>
      </div>
      <!-- <div class="form-check mb-4">
        <input
          type="checkbox"
          class="form-check-input"
          id="elo_szerzodes"
          name="consents[]"
          value="elo_szerzodes"
          v-model="elo_szerzodes"
        />
        <label for="hirlevel" class="form-check-label">
          <b>ELO_SZERZODES</b>
        </label>
      </div> -->
      <!-- <div class="form-check mb-4">
        <ValidationProvider
          name="adatkezelesi_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="adatkezelesi_nyilatkozat"
            name="consents[]"
            value="adatkezelesi_nyilatkozat"
            v-model="privacyStatement"
          />
        </ValidationProvider>
        <label for="adatkezelesi_nyilatkozat" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp; <b>Biztosításkötéssel kapcsolatos nyilatkozat</b
          ><br />
          Tudomásul veszem, hogy a Colonnade Insurance S.A. Magyarországi Fióktelepe (székhely: 1134
          Budapest, Váci út 23-27.) adatkezelő által a
          <a href="https://colonnade.nopa.hu" target="_blank">https://colonnade.nopa.hu</a>
          felhasználói adatbázisában tárolt személyes adataim átadásra kerülnek az OTP Mobil Kft.,
          mint adatfeldolgozó részére. Amennyiben más személyek személyes adatait adtam meg (vagy
          fogom megadni) a Biztosítónak, kijelentem, hogy az érintett személyeket tájékoztattam az
          adatvédelmi szabályzat tartalmáról, illetve ezen rendelkezéseknek megfelelően fel vagyok
          hatalmazva az érintett személyek személyes adatainak továbbítására a Biztosító részére. A
          Biztosító adatvédelmi szabályzata közvetlenül
          <a href="https://www.colonnade.hu/media/adatkezelesi-tajekoztato.pdf" target="_blank"
            >itt</a
          >
          elérhető.
        </label>
      </div> -->
      <div v-if="false" class="form-check mb-4">
        <ValidationProvider
          name="adatkezelesi_tajekoztato"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="adatkezelesi_tajekoztato"
            name="consents[]"
            value="adatkezelesi_tajekoztato"
            v-model="privacyStatement"
          />
        </ValidationProvider>
        <label for="adatkezelesi_tajekoztato" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp;adatkezelesi_tajekoztato
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="adatkezelesi_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="adatkezelesi_nyilatkozat"
            name="consents[]"
            value="adatkezelesi_nyilatkozat"
            v-model="ptkStatement"
          />
        </ValidationProvider>
        <label for="adatkezelesi_nyilatkozat" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp;
          <b
            >Nyilatkozat a szokásostól eltérő szerződési gyakorlat és a Ptk.-tól
            való eltérés elfogadásáról
            <div
              :class="ptkOpened ? 'arrow-up' : 'arrow-down'"
              @click="ptkClick"
            ></div></b
          ><br />
          <div v-show="ptkOpened">
            Kijelentem, hogy:<br />
            Tájékoztatást kaptam arra vonatkozóan, hogy a Colonnade Kivitelezői
            felelősségbiztosítása Biztosítási Feltételek alábbi rendelkezései
            lényegesen eltérnek a Polgári Törvénykönyvről szóló 2013. évi V.
            törvény (Ptk.) vonatkozó rendelkezéseitől:
            <ul>
              <li>
                A Ptk. 6:22.§ (1) bekezdésében foglalt 5 éves elévülési időtől
                eltérően a biztosítási szerződésből eredő igények két év alatt
                évülnek el).
              </li>
              <li>
                A Ptk. 6:63. § (5) bekezdésétől eltérően nem válik a Biztosítási
                szerződés tartalmává a Felek esetleges korábbi
                szerződéses/üzleti gyakorlata, szokása, illetve a biztosítási
                üzletágban a hasonló jellegű szerződés alanyai által széles
                körben ismert és rendszeresen alkalmazott szokás.
              </li>
              <li>
                A biztosítási szerződés a 2013.évi V törvény (Ptk) 6:443. § (1)
                pontjától eltérően a Szerződő írásbeli ajánlata és a Biztosító
                által ennek alapján kibocsátott fedezetet igazoló dokumentum
                /kötvény/ alapján jön létre.
              </li>
              <li>
                Kijelentem, hogy a Colonnade Kivitelezői Felelősségbiztosítása a
                szokásos szerződési gyakorlattól eltérő rendelkezéseit
                elfogadom, azokat magamra nézve kötelezőnek ismerem el.
              </li>
            </ul>
          </div>
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="szankcios_nyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="szankcios_nyilatkozat"
            name="consents[]"
            value="szankcios_nyilatkozat"
            v-model="privacyStatement"
          />
        </ValidationProvider>
        <label for="szankcios_nyilatkozat" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp; Kijelentem, hogy az általam
          képviselt társaság ismeri és betartja a szerződőre/biztosítottra,
          illetve az általuk folytatott gazdasági tevékenységre irányadó
          kereskedelmi és gazdasági szankciókat, korlátozásokat.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="oroszorszag"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="oroszorszag"
            name="consents[]"
            value="oroszorszag"
            v-model="orosz_nyilatkozat"
          />
        </ValidationProvider>
        <label for="oroszorszag" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp; Kijelentem, hogy az általam
          képviselt társaság/szerződő nem rendelkezik sem közvetetten, sem
          közvetlenül orosz, fehérorosz tulajdonossal vagy ellenőrző befolyást
          gyakorló személlyel (Oroszországban, Fehéroroszországban bejegyzett
          cég, vagy ezen országokban állandó lakcímmel rendelkező
          magánszemélyek); és az általam képviselt társaság/szerződő nem
          rendelkezik Oroszországban vagy Fehéroroszországban bejegyzett
          társasággal, eszközzel, érdekeltséggel vagy állandó telephellyel; és
          az általam képviselt társaság/szerződő közvetlenül nem értékesít
          semmilyen terméket, illetve nem nyújt semmilyen szolgáltatást orosz,
          fehérorosz piacra. Az általam képviselt társaság / szerződő nem
          vásárol semmilyen terméket, illetve szolgáltatást orosz, fehérorosz
          személy(ek)től (Oroszországban, Fehéroroszországban bejegyzett cégtől,
          vagy ezen országokban állandó lakcímmel rendelkező magánszemélyektől).
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="karnyilatkozat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="karnyilatkozat"
            name="consents[]"
            value="karnyilatkozat"
            v-model="karnyilatkozat_nyilatkozat"
          />
        </ValidationProvider>
        <label for="karnyilatkozat" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp; Az általam képviselt
          társaság erre jogosított képviseletében kijelentjük, hogy a mai napig
          nincs tudomásunk olyan eseményről, körülményről, adatról,
          információról, bejelentésről, igényről, amely a Colonnade Insurance
          S.A. Magyarországi Fióktelepével kötendő biztosítási szerződésünk
          tekintetében káresemény bekövetkezésére, a biztosítottakkal szembeni
          esetleges kárigény érvényesítésre vonatkozik, vagy amelyekből az
          általában elvárható körültekintés, az elvárható szakmai ismeretek,
          tapasztalatok alapján is következtetni lehet arra, hogy ilyen esemény
          bekövetkezett / bekövetkezik / bekövetkezhet és / vagy kárigény merült
          / merül / merülhet fel.
        </label>
      </div>
      <div v-if="merchant_id !== 'colo213'" class="form-check mb-4">
        <ValidationProvider
          name="biztositaskozvetito"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositaskozvetito"
            name="consents[]"
            value="biztositaskozvetito"
            v-model="sanctionsStatement"
          />
        </ValidationProvider>
        <label for="biztositaskozvetito" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp; Amennyiben a biztosítási
          szerződést biztosításközvetítő értékesíti, a biztosításközvetítő
          kijelenti, hogy az ügyletre megfelelő megbízással rendelkezik, a
          biztosító adatairól, a biztosítási szerződés jellemzőiről a
          biztosításkötést megelőző nyilatkozatok tartalmáról tájékoztatta az
          ügyfelet, aki a tájékoztatást és annak tartalmát tudomásul vette és
          elfogadta.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="tudomasul_veszem"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="tudomasul_veszem"
            name="consents[]"
            value="tudomasul_veszem"
            v-model="contrctReasonStatement"
          />
        </ValidationProvider>
        <label for="tudomasul_veszem" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp;
          <b
            >Biztosításkötéssel kapcsolatos nyilatkozat
            <div
              :class="tudomOpend ? 'arrow-up' : 'arrow-down'"
              @click="tudomClick"
            ></div></b
          ><br />
          <div v-show="tudomOpend">
            Tudomásul veszem, hogy:<br />
            <ul>
              <li>
                jelen ajánlat a Biztosító kockázat elbírálásának alapja;
              </li>
              <li>
                a Biztosítónak az ajánlattételtől számítva 15 nap áll
                rendelkezésére az ajánlat elbírálására;
              </li>
              <li>
                a Biztosító a kockázatelbírálás eredményeként az ajánlatot
                indoklás nélkül visszautasíthatja, ebben az esetben a
                biztosítási szerződés nem jön létre;
              </li>
              <li>
                ha a biztosítási esemény a kockázatelbírálási idő alatt
                bekövetkezik, a Biztosító az ajánlatot csak abban az esetben
                utasíthatja vissza, ha az igényelt biztosítási fedezet jellege
                vagy a kockázatviselés körülményei alapján nyilvánvaló, hogy az
                ajánlat elfogadásához a kockázat egyedi elbírálása szükséges;
              </li>
              <li>
                bármely szóbeli közlés vagy kikötés akkor érvényes, ha azokat a
                Biztosító írásban megerősítette;
              </li>
              <li>
                a Biztosító a Kivitelezői Felelősségbiztosítása termékkel
                kapcsolatosan nem nyújt tanácsadást, a termék értékesítése pedig
                közvetlenül a Biztosító online értékesítési felületén keresztül
                történik.
              </li>

              <li>
                a biztosítási szerződés megkötésére a jelen szerződéskötést
                megelőzően rendelkezésre bocsátott, ezen felületen megadott
                adatok alapján került sor
              </li>
              <li>
                a jogszabálynak való megfelelőség érdekében a valós adatok
                megadása és az adatváltozás bejelentése, illetve ez alapján a
                szerződés megfelelő módosítása a szerződő kötelezettsége. A
                biztosító nem vállal felelősséget azért, ha a biztosítás a
                szerződő által megadott adatok valótlansága vagy téves volta
                miatt, vagy az adatváltozás bejelentésének elmulasztása és a
                fedezet megfelelő módosításának elmulasztása miatt nem felel meg
                a jogszabályi előírásoknak.
              </li>
            </ul>
          </div>
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider
          name="ekapcsolat"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="ekapcsolat"
            name="consents[]"
            value="ekapcsolat"
            v-model="ekapcsolatStatement"
          />
        </ValidationProvider>
        <label for="ekapcsolat" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp;
          <b
            >Elektronikus kapcsolattartás nyilatkozat
            <div
              :class="ekapcsolatOpened ? 'arrow-up' : 'arrow-down'"
              @click="ekapcsolatClick"
            ></div></b
          ><br />
          <div v-show="ekapcsolatOpened">
            Hozzájárulok, hogy a Biztosító a biztosítási szerződéssel
            kapcsolatos kommunikációt elektronikus úton, az általam megadott
            email címen folytassa. Megértettem, hogy a Biztosító fenntartja a
            jogot, hogy egyes iratokat postai úton küldjön, ha jogszabály vagy
            hatósági előírás ezt megköveteli, vagy ha technikai akadályok
            merülnek fel. Elfogadom, hogy a hibás vagy elavult adatokból eredő
            késedelmekért a Biztosító nem felel.
          </div>
        </label>
      </div>
      <div v-if="false" class="form-check mb-4">
        <ValidationProvider
          name="elo_szerzodes"
          rules="required_checkbox"
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="elo_szerzodes"
            name="consents[]"
            value="elo_szerzodes"
            v-model="privacyStatement"
          />
        </ValidationProvider>
        <label for="elo_szerzodes" class="form-check-label"
          ><span class="text-danger">*</span>&nbsp;élő szerződés
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import Accesory from "./components/Accesory";
import { parse as parseMoney } from "vue-currency-input";
import PolicyCoverageVue from "./components/PolicyCoverage.vue";

export default {
  components: {
    Accesory,
    PolicyCoverageVue,
  },
  data() {
    return {
      insuranceTermsOpened: true,
      insuranceBondStatementOpened: false,
      contractPracticeStatementOpened: false,
      ptkOpened: false,
      tudomOpend: false,
      ekapcsolatOpened: false,
    };
  },
  computed: {
    ...mapFields([
      "startDate",
      "statementSettings.privacyStatement",
      "statementSettings.privacyProtection",
      "statementSettings.insuranceTerms",
      "statementSettings.electronicCommunation",
      "statementSettings.marketingMails",
      "statementSettings.acceptTerms",
      "statementSettings.validMerchant",
      "statementSettings.validDatas",
      "statementSettings.contrctReasonStatement",
      "statementSettings.ptkStatement",
      "statementSettings.ekapcsolatStatement",
      "statementSettings.sanctionsStatement",
      "statementSettings.elo_szerzodes",
      "statementSettings.orosz_nyilatkozat",
      "statementSettings.karnyilatkozat_nyilatkozat",
      "generalInfo.chosenSport",
      "generalInfo.chosenPackage",
      "generalInfo.privatePerson",
      "generalInfo.contractorVat",
      "generalInfo.propertyZip",
      "generalInfo.propertyName",
      "generalInfo.selectedPropertyName",
      "contractSettings.emailVerified",
      "contractSettings.emailVerifyToken",
      "contractSettings.merchantEmail",
      "riskSettings.companyLocationZip",
      "riskSettings.companyLocationCity",
      "riskSettings.companyLocationName",
      "riskSettings.companyLocationType",
      "riskSettings.companyLocationHouseNumber",
      "riskSettings.companyLocationBuilding",
      "riskSettings.locationZip",
      "riskSettings.locationCity",
      "riskSettings.locationName",
      "riskSettings.locationType",
      "riskSettings.locationHouseNumber",
      "riskSettings.locationBuilding",
      "riskSettings.locationTopography",
      "sportNames",
      "limitek",
      "sportok",
      "tc_id",
      "merchant_id",
      "product_code",
      "companyData.taxNumber",
      "companyData.companyname",
      "companyData.country",
      "companyData.zip",
      "companyData.city",
      "companyData.streetname",
      "companyData.streettype",
      "companyData.streetno",
      "companyData.streetother",
      "companyData.registrationdate",
      "companyData.companytype",
      "companyData.net_income",
      "companyData.profitaftertax",
      "companyData.totalassets",
      "companyData.equity",
      "companyData.yearofdata",
      "companyData.companytypecode",
      "companyData.companytypename",
      "companyData.displayedTaxNumber",
      "double_limit",
      "chosenLimit",
      "limittomb",
      "premium",
      "brokerData.brokercim",
      "brokerData.brokeremail",
      "brokerData.brokernev",
      "brokerData.brokertel",
      "chosenOnresz",
      "onresz",
      "period_discount",
      "period_discount_text",
    ]),
    ...mapFields({
      contractFor: "generalInfo.contractFor",
      propertyType: "generalInfo.propertyType",
      propertyOutskirts: "generalInfo.propertyOutskirts",
      propertyPhysicalJob: "generalInfo.propertyPhysicalJob",
      propertyOwnRight: "generalInfo.propertyOwnRight",

      acceptCalculatedInsurance:
        "insurancePersonalGoods.acceptCalculatedInsurance",
      calculatedInsurancePrice:
        "insurancePersonalGoods.calculatedInsurancePrice",

      paymentOptionsType: "paymentOptions.type",
      paymentOptionsFrequency: "paymentOptions.frequency",
      electronicContact: "electronicContact",
      electronicInsuring: "electronicInsuring",

      riskStartDate: "riskSettings.startDate",
      riskLocationName: "riskSettings.locationName",
      riskLocationType: "riskSettings.locationType",
      riskLocationHouseNumber: "riskSettings.locationHouseNumber",
      riskLocationBuilding: "riskSettings.locationBuilding",
      riskLocationTopography: "riskSettings.locationTopography",

      contractorCompanyName: "contractSettings.companyName",
      contractLastName: "contractSettings.lastName",
      contractFirstName: "contractSettings.firstName",
      contractMotherChildName: "contractSettings.motherChildName",
      contractBornName: "contractSettings.bornName",
      contractBornCity: "contractSettings.bornCity",
      contractBornDate: "contractSettings.bornDate",
      contractEmail: "contractSettings.email",
      contractPhoneNumberArea: "contractSettings.phoneNumberArea",
      contractPhoneNumber: "contractSettings.phoneNumber",
      contractPostAddressIsTheSame: "contractSettings.postAddressIsTheSame",

      contractLocationZip: "contractSettings.postAddress.locationZip",
      contractLocationCity: "contractSettings.postAddress.locationCity",
      contractLocationName: "contractSettings.postAddress.locationName",
      contractSelectedLocationName:
        "contractSettings.postAddress.selectedLocationName",
      contractLocationType: "contractSettings.postAddress.locationType",
      contractLocationHouseNumber:
        "contractSettings.postAddress.locationHouseNumber",
      contractLocationBuilding: "contractSettings.postAddress.locationBuilding",
      contractLocationTopography:
        "contractSettings.postAddress.locationTopography",

      contractedIsInsured: "insuredSettings.contractedIsInsured",
      insuredLastName: "insuredSettings.lastName",
      insuredFirstName: "insuredSettings.firstName",
      insuredMotherChildName: "insuredSettings.motherChildName",
      insuredBornName: "insuredSettings.bornName",
      insuredBornCity: "insuredSettings.bornCity",
      insuredBornDate: "insuredSettings.bornDate",
      insuredEmail: "insuredSettings.email",
      insuredPhoneNumberArea: "insuredSettings.PhoneNumberArea",
      insuredPhoneNumber: "insuredSettings.PhoneNumber",

      propertyIsMortgaged: "mortgageSettings.propertyIsMortgaged",
      mortgageCreditor: "mortgageSettings.creditor",
      mortgageCreditorLocation: "mortgageSettings.creditorLocation",
      mortgageId: "mortgageSettings.mortgageId",
      mortgagePrice: "mortgageSettings.mortgagePrice",
      mortgageCurrency: "mortgageSettings.mortgageCurrency",
      mortgageStartDate: "mortgageSettings.mortgageStartDate",
      mortgageEndDate: "mortgageSettings.mortgageEndDate",
      ertekesito_koti: "ertekesito_koti",
      dm: "dm",
      contractReason: "kotes_oka",
    }),

    chosenAccesories: function() {
      let accesories = {};

      Object.entries(
        this.$store.state.chooseableAccesories.selectableList,
      ).forEach((accesory) => {
        if (accesory[1]?.selected) accesories[accesory[0]] = accesory[1];
      });

      return accesories;
    },
    stringPropertyType: function() {
      switch (this.propertyType) {
        case "tarsashaz":
          return "Társasházi lakás";
        case "csaladihaz":
          return "Családi ház";
        case "sorhaz":
          return "Sorház";
        case "ikerhaz":
          return "Ikerház";
      }
    },
    contractorNameText: function() {
      if (this.merchant_id == "nsu") return "Csatlakozási nyilatkozatot tevő";
      else return "szerződő";
    },
    packageName: function() {
      if (this.chosenPackage == "alap") return "Alap csomag";
      else if (this.chosenPackage == "kozepes") return "Közepes csomag";
      else return "Kiemelt csomag";
    },
    limitName: function() {
      if (this.double_limit == "simple_limit") return "Szimpla limit";
      else return "Dupla limit";
    },
    stringPropertyOwnType: function() {
      switch (this.propertyOwnRight) {
        case "sajat":
          return "Saját tulajdon saját használatban";
        case "sajat_berbe":
          return "Saját tulajdon bérbe adva";
        case "berlemeny":
          return "Bérlemény";
      }
    },
    stringPaymentType: function() {
      switch (this.paymentOptionsType) {
        case "csoportos":
          return "Csoportos beszedési megbízás";
        case "online":
          return "Online bankkártyás fizetés";
        case "banktransfer":
          return "Átutalás";
        case "csekk":
          return "Postai csekk";
      }
    },
    stringPaymentFrequency: function() {
      switch (this.paymentOptionsFrequency) {
        case "yearly":
          return "Éves";
        case "feleves":
          return "Féléves";
        case "negyedeves":
          return "Negyedéves";
        case "havi":
          return "Havi";
      }
    },
    paymentFrequentString() {
      const frequency = this.$store.state.paymentOptions.frequency;
      let stringFrequency;
      if (frequency == "eves") stringFrequency = " /év";
      else if (frequency == "feleves") stringFrequency = " /félév";
      else if (frequency == "negyedeves") stringFrequency = " /negyedév";
      else stringFrequency = " /hó";
      return (
        this.$options.filters.currency(
          this.$store.state.gyakorisag_szerint_fizetendo_dij,
        ) + stringFrequency
      );
    },
  },

  methods: {
    ...mapActions(["verifyPage", "EmailValidationCode"]),
    insuranceTermsClick(e) {
      if (e) e.preventDefault();
      this.insuranceTermsOpened = !this.insuranceTermsOpened;
    },
    ptkClick(e) {
      if (e) e.preventDefault();
      this.ptkOpened = !this.ptkOpened;
    },
    tudomClick(e) {
      if (e) e.preventDefault();
      this.tudomOpend = !this.tudomOpend;
    },
    ekapcsolatClick(e) {
      if (e) e.preventDefault();
      this.ekapcsolatOpened = !this.ekapcsolatOpened;
    },
    insuranceBondStatementClick(e) {
      if (e) e.preventDefault();
      this.insuranceBondStatementOpened = !this.insuranceBondStatementOpened;
    },
    contractPracticeStatementClick(e) {
      if (e) e.preventDefault();
      this.contractPracticeStatementOpened = !this
        .contractPracticeStatementOpened;
    },
    stringPropertyWall: function(str) {
      switch (str) {
        case "tegla":
          return "Tégla";
        case "beton":
          return "Beton";
        case "ko":
          return "Kő";
        case "panel":
          return "Panel";
        case "konnyuszerk":
          return "Könnyűszerkezetes";
        case "fa":
          return "Fa";
        case "valyog":
          return "Vályog";
        case "vegyes":
          return "Vegyes (vályog és szilárd)";
      }
    },
    stringPropertyRoof: function(str) {
      switch (str) {
        case "cserep":
          return "Cserép";
        case "pala":
          return "Pala";
        case "nad":
          return "Nád";
        case "fazsindely":
          return "Fazsindely";
        case "szalma":
          return "Szalma";
        case "bitumen":
          return "Bitumenes";
        case "muanyag":
          return "Műanyag";
        case "fem":
          return "Fém";
        case "hullamlemez":
          return "Bitumenes hullámlemez";
      }
    },
    getAge(birthDate) {
      var today = new Date();
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    isYesterdayOrLater(startDate) {
      const today = new Date();
      const givenDate = new Date(startDate);

      // Set the time to midnight for both dates to avoid hour comparisons
      givenDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      return givenDate <= today; // true for yesterday or earlier, false for today or future
    },
  },
  watch: {
    emailVerifyToken: function(value) {
      if (btoa(value) == this.$store.state.email_valid_code)
        this.emailVerified = true;
    },
  },
  created: function() {
    if (!this.$store.state.email_valid_code) this.EmailValidationCode();
  },
};
</script>

<style lang="scss" scoped>
$red: #e4002b;

ul.hyphens {
  list-style-type: none;
}

ul.hyphens > li:before {
  content: "–";
  position: absolute;
  margin-left: -1.1em;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-bottom: 10px solid $red;
  margin-left: 5px;
  display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-top: 10px solid $red;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}

.form-check-label {
  margin-top: -20px;
  margin-left: 5px;
}
</style>
